import { IAction } from '@ws/shared/types';
import { toast } from 'react-toastify';
import { call, delay, put, takeEvery } from 'typed-redux-saga';

import { getResourceManager } from '../../resources/ResourceManager';
import { createApiActionError } from '../../utils/createApiActionError';
import { clearLogoutIntent } from '../sync/logoutIntentState';
import { logoutIntent, syncReconcile } from '../sync/sync.actions';

import { getUserInfo, logoutUser } from './user.actions';
import {
  IAuthStatusAction,
  IUserGetInfoSuccess,
  USER_GET_INFO,
  USER_LOGOUT,
  USER_SET_AUTH_STATUS,
} from './user.types';
import { setListOfRemoteProjects } from '../remote';

function* getUserInfoSaga() {
  yield* put(getUserInfo.request());

  try {
    const resourceManager = getResourceManager();
    const getInfo = resourceManager.UserService.getInfo.bind(resourceManager.UserService);
    const checkData = yield* call(getInfo);

    if (checkData.isOk && checkData.customer) {
      // Успешный login — намерение выйти сброшено; супервизор переоценит синк.
      clearLogoutIntent();
      yield* put(getUserInfo.success<IUserGetInfoSuccess>({ customer: checkData.customer }));
      yield* put(syncReconcile({ reason: 'auth-change' }));
    } else {
      yield* put(
        getUserInfo.failure(null, { errorMessage: 'Error occurred during user data fetch!' }),
      );
    }
  } catch (error) {
    yield* put(getUserInfo.failure(null, createApiActionError(error)));
  }
}

function* logoutSaga() {
  yield* put(logoutUser.request());
  // Намерение выйти ставим ДО сетевого запроса: даже если logout по сети упадёт,
  // синк остаётся остановленным (пользователь хотел выйти); сбросит успешный login.
  yield* put(logoutIntent());

  try {
    const resourceManager = getResourceManager();
    const logoutFunc = resourceManager.AuthService.logout.bind(resourceManager.AuthService);
    const { isOk } = yield* call(logoutFunc);

    if (isOk) {
      toast.success('Successfully logged out!');
    } else {
      toast.error('Something went wrong!');
    }

    yield* delay(300);
    yield* put(setListOfRemoteProjects());
    yield* put(getUserInfo());
  } catch (error) {
    yield* put(logoutUser.failure(null, createApiActionError(error)));
  }
}

function* changeUserAuthStatusEffect(_action: IAction<IAuthStatusAction>) {
  // И вход, и выход из auth — просто триггер reconcile: супервизор сам решит
  // (авторизован → probe/resume; нет → PAUSE(auth-required)). USER_SET_AUTH_STATUS(false)
  // приходит и от 401-истечения — намерение выйти при этом НЕ ставится (только logout).
  yield* put(syncReconcile({ reason: 'auth-change' }));
}

export function* userWatch() {
  yield* takeEvery(USER_GET_INFO.DEFAULT, getUserInfoSaga);
  yield* takeEvery(USER_LOGOUT.DEFAULT, logoutSaga);
  yield* takeEvery(USER_SET_AUTH_STATUS, changeUserAuthStatusEffect);
}
